export const MAX_DAILY_REPORT_HOURS = 2_147_483_647;

export function isDailyReportHoursValue(value: unknown): value is number {
  return typeof value === "number"
    && Number.isFinite(value)
    && value >= 0
    && value <= MAX_DAILY_REPORT_HOURS
    && Number.isInteger(value * 2);
}

export function normalizeDailyReportHours(value: unknown): number | null {
  const parsedHoursValue = typeof value === "number"
    ? value
    : typeof value === "string" && value.trim() !== ""
      ? Number(value)
      : Number.NaN;
  return isDailyReportHoursValue(parsedHoursValue) ? parsedHoursValue : null;
}

export function formatDailyReportHours(hours: number): string {
  return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 1 }).format(hours);
}
